module.exports = __webpack_public_path__ + "img/waterproof.4c2ba87c.jpg";